import AddToCart from "../Elements/AddToCart";
export default function OddsBooster ({competition}) {

	return (
		<div className="zap-checkout-block-odds-booster">
			<div className="zap-checkout-odds-booster-title">
				<span><i className="fa fa-percent"></i></span>
				Increase your odds, and save with these ticket bundles!
			</div>
			<div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridGap: '1em'}}>
				{competition.discount_breaks.map((discount_break) => (
					<AddToCart competition={competition} qty={discount_break.tickets}>
						<div>{discount_break.tickets} Tickets</div> {discount_break.discount}% Off
					</AddToCart>
				) )}
			</div>
		</div>
	);
}